import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import BrandButton from 'components/BrandButton';
import Link from 'components/Link';

import cn from './styles.local.less';

export default class DefaultPromo extends PureComponent {
  static propTypes = {
    content: PropTypes.string,
    imageSource: PropTypes.string,
    linkSource: PropTypes.string,
    linkTitle: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { linkSource, linkTitle, content, imageSource, onClick, title } =
      this.props;

    if (!linkSource) {
      return null;
    }

    return (
      <Link
        to={linkSource}
        onClick={onClick}
        data-qa-selector="promo"
        className={cn.root}
      >
        <img alt="promo" className={cn.sideImage} src={imageSource} />
        <div className={cn.main}>
          <header>
            <div className={cn.title}>{title}</div>
          </header>
          <div className={cn.content}>
            <img alt="promo" className={cn.image} src={imageSource} />
            <p className={cn.contentBody}>{content}</p>
          </div>
          <footer className={cn.footer}>
            <BrandButton className={cn.link} bsSize="small">
              {linkTitle}
            </BrandButton>
          </footer>
        </div>
      </Link>
    );
  }
}
